import { Outlet, createFileRoute } from "@tanstack/react-router";
import { useMemo } from "react";

import { HostAdapterContext } from "@/clients/host/adapter";
import { FramerHostAdapter } from "@/clients/host/framer";

export const Route = createFileRoute("/plugin/framer")({
  component: FramerLayout,
});

function FramerLayout() {
  const adapter = useMemo(() => new FramerHostAdapter(), []);

  return (
    <HostAdapterContext.Provider value={adapter}>
      <Outlet />
    </HostAdapterContext.Provider>
  );
}
